import type { InputHTMLAttributes, ReactNode, Ref } from 'react';
import { cx } from '@parrot/utils';
import styles from './Checkbox.module.css';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> & {
  /** Sits beside the box. Omit it only if something else names the control. */
  label?: ReactNode;
  size?: 'sm' | 'md';
  ref?: Ref<HTMLInputElement>;
};

/**
 * A real, focusable `<input type="checkbox">` styled with `appearance: none` —
 * not a hidden input with a box drawn beside it, which has to rebuild keyboard
 * access, focus and screen-reader semantics by hand.
 *
 * The `<label>` wraps the input, so they're associated without an `id`.
 */
export const Checkbox = ({ label, size = 'md', className, ...inputProps }: Props) => (
  <label className={cx(styles.base, styles[size], className)}>
    <input type={'checkbox'} className={styles.input} {...inputProps} />
    {label !== undefined && <span className={styles.label}>{label}</span>}
  </label>
);
